import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../constants';
import { ShareContext } from '../context/ShareContext';
import BackLoader from '../components/backloader';
import JisButton from '../components/controls/jisButton';
import JisCheckbox from '../components/controls/jisCheckbox';
import JisYesNo from '../components/controls/jisYesNo';
import JisDialog from '../components/dialog';
import Pagenated from '../components/pagenated';
import PdfViewer from '../components/controls/pdfviewer';
import JisTabButton from '../components/controls/jisTabButton';
import JisDialogForm from '../components/formdialog';


function Fiats() {

    const navigate = useNavigate();
    const {  activePage, token, profile,frequentData,setIsExpired} = useContext(ShareContext);
    const [fiatCases, setFiatCases] = useState([]);
    const [loading, setLoading] =useState(false);
    const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);
    const [count, setCount] = useState(0);
    const [isPreview, setIsPreview] = useState(false);
    const [caseFiat, setCaseFiat] = useState(null);
    const [fiatUrl, setFiatUrl] =useState('');
    const [approval,setApproval] = useState({isPay:true, isApproved:null});
    const [err, setErr] = useState('');
    const [affected, setAffected] = useState(0);
    const [showApproval, setShowApproval] =useState(false)
    const [index, setIndex] = useState(-1);
    const [tab,setTab]= useState('pending');
    
      useEffect(() => {
        
          onLoad();       
    }, []);

    useEffect(() => {
        if(pageIndex>=0){
          onLoad();
        }
                 
    }, [pageIndex,tab]);

    const onChangeTab=(t)=>{
      setTab(t);
      setPageIndex(0);
    }
     const onLoad= async()=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/get-fiats/${tab}/${pageIndex}/${pageSize}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                //ready
                // fee, feelines, cinfo , parties 
              setFiatCases(data.items)
              if(pageIndex==0){
                setCount(data.totalCount);
              } 
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }

        const onSave=async(e)=>{
          e.preventDefault();
          if(approval.isApproved==null){
            setErr('Please select the approval option');
            return;
          }
          setErr('');
           var approve={...approval,id:caseFiat.fiat.id};
             
                  setLoading(true)
                  try {
                    
                    const resp = await fetch(`${Constants.apiUrl}/filing/fiat-approval`, {
                      method: 'POST',
                      body:JSON.stringify(approve) ,
                      headers: {
                        'Content-Type': 'application/json, text/plain',
                        Authorization: `Bearer ${token}`,
                      },
                    });
                    
                    const data = await resp.json();
                    setLoading(false);
                    console.log(data);
                   if(data.code==0){
                    //update the field
                      setShowApproval(false);
                      setIsPreview(false);
                    onLoad();
                   } else if(data.code==-10){
                      setIsExpired(true);
                  }else{
                    //there is an error
                    setErr(data.status);
                   }
                    
                  } catch (error) {
                    setLoading(false);
                    console.error(error);
                    setErr(Constants.serverErr);
                   // onMove();
                  }
    }
const onContinue=(opt,ind)=>{
setIndex(ind);
    setCaseFiat(opt);
    setFiatUrl(Constants.AbsoluteFiletoRelative(opt.fiat.doc) );
    setIsPreview(true);
   // navigate(`/case-filing/${caseid}`)
}
 const onPagePick=(pick)=>{
    console.log('this is selection value');
    setPageIndex(pick.id-1)
    console.log(pick)
}
  return (
    <div>
      
    <div className='tab_body'>
      <div className='tab_section'>
        <JisTabButton isActive={tab=='pending'}   title="Pending Fiats" 
       isRoleBased={false} onClick={()=> onChangeTab('pending')}/>

       <JisTabButton isActive={tab=='approved'}   title="Approved Fiats" 
       isRoleBased={false} onClick={()=> onChangeTab('approved')}/>

        <JisTabButton isActive={tab=='rejected'}   title="Rejected Fiats" 
       isRoleBased={false} onClick={()=> onChangeTab('rejected')}/>
      </div>
      <div className='tab_view'>

      </div>
    </div>

<div className='table'>
  <div class="section-cases">
  <span>Fiats</span><span className='total'>{count}</span>
</div>
      <table class="case-table">
  <thead>
    <tr>
      <th>Suit Number</th>
      <th>Case Title</th>
      <th>Filing Type</th>
      <th>Classification</th>
      <th>Legal Counsel</th>
      <th>Date Filed</th>
      <th>Approval Status</th>
      <th>Allow Payment</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
     {fiatCases?.map((opt, ind) => (
       <tr key={ind}>
      <td>{opt.case?.referenceNumber}</td>
      <td>{opt.case?.caseTitle}</td>
      <td>{Constants.getItemById(frequentData?.casetype,opt.case?.caseTypeId)?.caseType1}</td>
      <td> {Constants.getItemById(frequentData?.casecategories,opt.case?.caseCategoryId)?.categoryTitle}</td>
      <th>{opt.legalCounselFirstName} {opt.legalCounselLastName}</th>
      <td> {Constants.momentDate(opt.fiat?.createdOn).format('DD MMM, YYYY')}</td>
      <td>{opt.fiat?.isApproved==null?'pending':(opt.fiat?.isApproved?'Approved':'Rejected')}</td>
      <td>{opt.fiat?.isApproved==null?'pending':(opt.fiat?.isPay && opt.fiat?.isApproved?'Zero Payment':'Payment Required')}</td>
      <td><JisButton variant='plain' onClick={()=>onContinue(opt,ind)}>View</JisButton></td>
    </tr>
    ))} 
    


  </tbody>
</table>
 {fiatCases?.length>0 && <Pagenated onChangePageSize={(k)=>setPageSize(k)} size={pageSize} total={count} maxPage={20}  onPick={onPagePick}/>}    
</div>

{isPreview && <div className={  "preview open" } style={{overflow:'scroll'}}>
                <div className="heading">
                  <div className='buttongroup'>
                  {caseFiat.fiat.isApproved==null && <JisButton icon="done"  onClick={() => setShowApproval(true)}> Show Approve or Reject</JisButton>}  
                    <JisButton icon="close"  onClick={() => setIsPreview(false)}> Close Preview</JisButton>
                    
                        
                     </div>
                     
                  

                  
                </div>
               <PdfViewer   pdfUrl={fiatUrl}/>
               
                
                <div className="date-btns">
                    
                  
                </div>
            </div>} 
    {showApproval && <JisDialogForm title="FIAT Approval" onClose={()=> setShowApproval(false)}>
<form onSubmit={onSave}>
                      <div>
                     {/*  <JisCheckbox label="Uncheck if this fiat still require payment" value={approval.isPay} onChange={(e)=>setApproval({...approval,isPay:e}) } /> */}
                        <JisYesNo  label="Please Choose the Approval Status" value={approval.isApproved} yes="Approve" 
                        no="Reject"  onChange={(e)=>setApproval({...approval,isApproved:e}) } applyButtonStyle={true}/> 
                         <div  className="input-group">
                              <label>Comment <span className="required">*</span> </label>
                              <div className='input-wrapper'>
                                  <DynamicIcon iname="group" />
                                  <textarea placeholder=' Comment' required={true}  value={approval.comment}
                            onChange={(e)=>setApproval({...approval,comment:e.target.value}) }  />
                              </div>
                          </div> 
                        {err!="" && <div className='error'>{err}</div>}
                        <div className='groupbtn'>
                          <JisButton type="submit">Save </JisButton>     
                          <JisButton variant='outline' type="button" onClick={()=> setShowApproval(false)}>Cancel </JisButton> 
                        </div>
                                    
                    </div>
                     </form>
      </JisDialogForm>}        
<BackLoader open={loading} />
    </div>
  );
}

export default Fiats;